module.exports = __webpack_public_path__ + "static/img/refresh.532ee460.png";